import HasToBeBackofficeGuard from 'app/core/guards/HasToBeBackofficeGuard';
import HasToBeLoggedInGuard from 'app/core/guards/HasToBeLoggedInGuard';
import React from 'react';
import { RouteConfig } from 'react-router-config';

const PREFIX = '/backoffice/';

const backofficeRoutes: Array<RouteConfig> = [
  {
    path: PREFIX + 'dashboard',
    component: React.lazy(
      () => import('../../../main/backoffice/dashboard/BackofficeDashboard')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'inspectors/new',
    component: React.lazy(
      () =>
        import('../../../main/construction/inspectors/create/CreateInspector')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'inspectors',
    component: React.lazy(
      () =>
        import('../../../main/construction/inspectors/InspectorsListingPage')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: '/inspectors/:id/:sectionId',
    component: React.lazy(
      () =>
        import(
          '../../../main/construction/inspectors/profile/InspectorProfilePage'
        )
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: '/inspectors/:id',
    component: React.lazy(
      () =>
        import(
          '../../../main/construction/inspectors/profile/InspectorProfilePage'
        )
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
  {
    path: PREFIX + 'account',
    component: React.lazy(
      () => import('../../../main/agency/account/AccountProfilePage')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeBackofficeGuard],
  },
];

export default backofficeRoutes;
